import React, { useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { FileHiddenInput } from "hesus-ui-kit";
import "./DocumentUpload.scss";
import { ButtonWrapperRelative, CreateButton } from "../../DocumentList.styled";
import UserInfo from "@utils/UserInfo";

const DocumentUpload = (props) => {
  const { t, entityId, entityType, entityDataType, setData, entityData } =
    props;
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const fileInputRef = useRef();

  let documentTypes = {};
  // Get user details from localStorage (JWT auth)
  const userDetails = UserInfo.getUser();
  documentTypes = entityDataType &&
    entityDataType === "center" && [
      {
        id: "3",
        label: "TYPE_OTHER",
      },
      { id: "17", label: "TYPE_PRIOR_ACCEPTANCE" },
      { id: "18", label: "TYPE_WASTE_TRACKING_SLIP" },
    ];
  if (entityType === "siteId") {
    documentTypes = !entityDataType && [
      { id: "1", label: "TYPE_CHEMICAL_ANALYSIS" },
      { id: "2", label: "TYPE_OTHER_ANALYSIS" },
      { id: "3", label: "TYPE_OTHER" },
      { id: "6", label: "TYPE_POLLUTION_PARAMETERS" },
      { id: "11", label: "TYPE_SUPPLIER_QUOTE" },
      { id: "14", label: "TYPE_SITE_STATISTICS" },
      { id: "15", label: "TYPE_HESUS_QUOTE" },
      { id: "21", label: "TYPE_CLIENT_CONSULTATION" },
      { id: "22", label: "TYPE_PURCHASE_ORDER" },
      { id: "23", label: "TYPE_SITE_PROTOCOL" },
    ];
  }
  if (entityType === "companyId") {
    documentTypes =
      !entityDataType &&
      (entityData?.isCentre
        ? [
            { id: "3", label: "TYPE_OTHER" },
            { id: "17", label: "TYPE_PRIOR_ACCEPTANCE" },
            { id: "18", label: "TYPE_WASTE_TRACKING_SLIP" },
          ]
        : [{ id: "3", label: "TYPE_OTHER" }]);
  }

  if (entityType === "requestId") {
    documentTypes = !entityDataType && [
      { id: "1", label: "TYPE_CHEMICAL_ANALYSIS" },
      { id: "2", label: "TYPE_OTHER_ANALYSIS" },
      { id: "3", label: "TYPE_OTHER" },
      { id: "6", label: "TYPE_POLLUTION_PARAMETERS" },
      { id: "11", label: "TYPE_SUPPLIER_QUOTE" },
      { id: "21", label: "TYPE_CLIENT_CONSULTATION" },
    ];
  }

  const uploadDropdownToggle = () => {
    setDisplayDropdown(!displayDropdown);
  };

  const triggerUploadInput = (type) => {
    fileInputRef.current.setAttribute("data-type", type);
    fileInputRef.current.click();
  };

  const onFileSelect = (e) => {
    uploadDropdownToggle();
    const dataModified = new FormData();
    if (e.target.files.length > 0) {
      dataModified.append(entityType, entityId);
      dataModified.append(`type`, e.target.dataset.type);
      dataModified.append(`adminId`, userDetails.id);
      for (let i = 0; i < e.target.files.length; i++) {
        const documentObject = e.target.files[i];
        dataModified.append(`file[${i}][filename]`, documentObject.name);
        dataModified.append(`file[${i}][file]`, documentObject);
      }
      // setLoading(true);
      axios
        .post(`/documents`, dataModified, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          setData(response?.data?.documents);
          // setLoading(false);
        })
        .catch((error) => {});
    }
  };

  return (
    <>
      <ButtonWrapperRelative>
        <CreateButton
          displayDropdown={displayDropdown}
          onClick={uploadDropdownToggle}
        >{`${t("ACTION_NEW_DOCUMENT")}`}</CreateButton>
        {displayDropdown && (
          <div className="document-upload-dropdown-container">
            <ul className="document-dropdown-list">
              {documentTypes.map((item) => (
                <li
                  key={item.id}
                  className="document-upload-list-item"
                  onClick={() => triggerUploadInput(item.id)}
                >
                  <label className="document-label">{t(item.label)}</label>
                </li>
              ))}
            </ul>
            <FileHiddenInput
              type="file"
              id="document"
              inputClass="document-upload-input-field"
              onFileSelect={onFileSelect}
              fileInputRef={fileInputRef}
            />
          </div>
        )}
      </ButtonWrapperRelative>
    </>
  );
};

DocumentUpload.propTypes = {
  t: PropTypes.func.isRequired,
  entityId: PropTypes.number.isRequired,
  entityType: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired,
  entityDataType: PropTypes.string,
  entityData: PropTypes.object,
};

DocumentUpload.defaultProps = {
  entityDataType: null,
  entityData: null,
};

export default withTranslation()(DocumentUpload);
